import {createSelector} from 'reselect';

import {getNavigation, getTranslations} from './store';
import {getIsMobile} from './system';
import getAvailabilityCalendar from './availabilityCalendar';
import getLayout, {MAIN_CONTENT_SECTIONS} from './layout';
import {getMultiUnitsLayoutValues} from './multiUnits';
import {getHostType} from './listing';

const getNavLabels = createSelector(
    [getTranslations, getAvailabilityCalendar, getMultiUnitsLayoutValues, getHostType],
    (trans, availabilityCalendar, multiUnitsLayoutValues, hostType) => {
        return {
            [MAIN_CONTENT_SECTIONS.overview]: trans.navOverview,
            [MAIN_CONTENT_SECTIONS.amenities]: trans.navAmenities,
            [MAIN_CONTENT_SECTIONS.reviews]: trans.navReviews,
            [MAIN_CONTENT_SECTIONS.map]: trans.navMap,
            [MAIN_CONTENT_SECTIONS.rates_availability]: availabilityCalendar.shouldShowRates
                ? trans.navRatesAvailability
                : trans.navAvailability,
            [MAIN_CONTENT_SECTIONS.other_units]: multiUnitsLayoutValues.isHotelType
                ? trans.navRooms
                : trans.navUnits,
            [MAIN_CONTENT_SECTIONS.policies]: trans.navPolicies,
            [MAIN_CONTENT_SECTIONS.ownerManager]: hostType.owner ? trans.owner : trans.managerCap
        };
    }
);

const getNavTabsDynamic = createSelector(
    [getLayout, getNavLabels],
    (layout, navLabels) => {
        return layout.order.map(({name}) => ({
            id: name,
            href: `#${name}`,
            label: navLabels[name]
        }));
    }
);

const getNavActiveTabIndex = createSelector(
    [getNavigation],
    (navigation) => navigation.navActiveTabIndex
);

const getNavData = createSelector(
    [getNavTabsDynamic, getNavActiveTabIndex, getIsMobile],
    (navTabs, activeIndex, isMobile) => ({navTabs, activeIndex, isMobile})
);

const NAV_TABS = MAIN_CONTENT_SECTIONS;

export default getNavData;
export {getNavLabels, getNavData, NAV_TABS};
